import {
  updateReadTaskReadTasksPatch,
  UpdateReadTaskReadTasksPatchResponse,
  UpdateReadTaskReadTasksPatchData,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const UsePatchTaskMutation = (): UseMutationResult<
  UpdateReadTaskReadTasksPatchResponse,
  AxiosError<HTTPValidationError>,
  UpdateReadTaskReadTasksPatchData
> => {
  return useMutation<
    UpdateReadTaskReadTasksPatchResponse,
    AxiosError<HTTPValidationError>,
    UpdateReadTaskReadTasksPatchData
  >({
    mutationFn: async ({ body, query }) => {
      const response = await updateReadTaskReadTasksPatch({
        body: body,
        query: query,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ReadTasksList'] })
    },
  })
}
